export default __webpack_public_path__ + "static/media/solucao-09.80962679.webp";